import projectDetailFragment from './Fragments/projectDetailFragment'

const getCustomerProjectsQuery = /* GraphQL */ `
  query GetCustomerProjects($webUserGuid: String = null, $selectedFacetData: SelectedFacetDataDMInput = null) {
    customerProjects(webUserGuid: $webUserGuid, selectedFacetData: $selectedFacetData) {
      ...ProjectDetailFragment
    }
  }
  ${projectDetailFragment}
`

export { projectDetailFragment }
export default getCustomerProjectsQuery
